import { fork } from "redux-saga/effects";

import watchLoginAsync from "../containers/login/saga";
import watchDashboardAsync from "../containers/dashboard/saga";
import watchCompanyDashboardAsync from "../containers/companyDashboard/saga";
import watchEmployeeRegistrationAsync from "../containers/employeeConfirmRegistration/saga";
import watchOnboradCompanyAsync from "../containers/companyRegistration/saga";
import watchOnboardVendorAsync from "../containers/vendorRegistration/saga";
import watchReportsAsync from "../containers/reports/saga";
import watchContactSupportAsync from "../containers/contactSupport/saga";
import watchVendorDashboardAsync from "../containers/vendorDashboard/saga";
import watchFeatureFlagsAsync from "../containers/featureFlags/saga";
import watchEngagementAsync from "../containers/engagement/saga";

export function* rootSaga() {
  yield fork(watchLoginAsync);
  yield fork(watchDashboardAsync);
  yield fork(watchCompanyDashboardAsync);
  yield fork(watchEmployeeRegistrationAsync);
  yield fork(watchOnboradCompanyAsync);
  yield fork(watchOnboardVendorAsync);
  yield fork(watchReportsAsync);
  yield fork(watchContactSupportAsync);
  yield fork(watchVendorDashboardAsync);
  yield fork(watchFeatureFlagsAsync);
  yield fork(watchEngagementAsync);
}
